import { gql } from '@apollo/client'

// The redesigned review step shows "Adult / Junior · email" under the student's
// name, so it asks for `isMinor` and the representatives' emails on top of what
// the legacy `GetStudentQuery` (../../queries.js) loads.
export const ReviewStudentQuery = gql`
  query ReviewStudentQuery($id: ID!) {
    student(id: $id) {
      id
      firstName
      lastName
      isMinor
      golferProfile {
        id
      }
      representatives {
        relationshipType
        contact {
          id
          externalId
          email
        }
      }
    }
  }
`
